import { memo, useCallback } from "react"
import { Box, IconButton, Typography } from "@mui/material"
import { t } from "@lingui/macro"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"

import ContentPasteOutlinedIcon from "@mui/icons-material/ContentPasteOutlined"

import { IContractHeaderProps } from "src/views/contracts/pages/details/types/contract-detail"
import { useGetContractStatus } from "src/views/contracts/hooks/useGetContractStatus"
import { StatusChip } from "src/components/StatusChip"

export const ContractHeader = memo(
    ({ contract, onBackClick }: IContractHeaderProps) => {
        const { getStatusState } = useGetContractStatus()

        const handleBackClick = useCallback(() => {
            onBackClick()
        }, [onBackClick])

        return (
            <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                <IconButton
                    onClick={handleBackClick}
                    sx={{ mr: 1 }}
                    aria-label={t`contract-details.back-to-contracts`}
                >
                    <ArrowBackIcon />
                </IconButton>
                <Box display="flex" alignItems="center">
                    <ContentPasteOutlinedIcon
                        sx={{ mr: 1, color: "primary.main" }}
                    />
                    <Typography variant="body1">
                        <strong>{t`contract-details.contract-id`} : </strong>
                        <strong style={{ marginRight: 6 }}>
                            {contract?.lease_contract_id ?? ""}
                        </strong>
                    </Typography>
                </Box>
                {contract?.status != null && (
                    <StatusChip
                        state={getStatusState(contract.status ?? null)}
                        label={contract.status}
                    />
                )}
            </Box>
        )
    },
)
